import { Outlet } from 'react-router-dom';
import useInstantPayEnabled from '@/enterprise/components/InstantPay/useInstantPayEnabled';
import useEnableUnification from '@/enterprise/components/useEnableUnification';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';

const InstantPayLayout = () => {
  const isEnabled = useInstantPayEnabled();
  const enableUnification = useEnableUnification();

  if (!isEnabled) {
    const to = enableUnification ? asEnterpriseLink('homepage') : asEnterpriseLink('customers');
    return <NavigateWithRedirect to={to} />;
  }

  return <Outlet />;
};

export default InstantPayLayout;
